import { CommonModule } from '@angular/common';
import { RouterModule, RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { Component, AfterViewInit } from '@angular/core';
import { NavbarComponent } from '../navbar/navbar.component';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [RouterOutlet, CommonModule, RouterModule, SidebarComponent, NavbarComponent],  
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements AfterViewInit {

  ngAfterViewInit() {
    const sidebar = document.querySelector('app-sidebar');
    
    const ul = sidebar?.querySelector('ul');

    const liCount = ul?.querySelectorAll('li').length;

    if (liCount == 1) {
      sidebar?.remove();
    }
  }

}
